import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/cost")({
  component: () => <Outlet />,
});
